import { formatSrtTime } from "./time.js";
import type { SubtitleCue } from "./types.js";

export function cuesToSrt(cues: SubtitleCue[]): string {
  return cues
    .map((cue, cueIndex) => {
      const index = cue.index ?? cueIndex + 1;
      return [
        String(index),
        `${formatSrtTime(cue.startUs)} --> ${formatSrtTime(cue.endUs)}`,
        cue.text
      ].join("\n");
    })
    .join("\n\n")
    .concat(cues.length > 0 ? "\n" : "");
}
